import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { InternalTrainingVM } from "@shared-kernel/application/ports/admin/admin-repository";
import {
  adminRetrieveInternalTrainings,
  resetAdminRetrieveInternalTrainings,
} from "@academy-context/read/application/use-cases/admin/internal-trainings-retrieval/retrieve-internal-trainings";

const initialState: RetrievalState<InternalTrainingVM[]> = { data: [], fetching: "idle" };

export const adminRetrieveInternalTrainingsReducer = createReducer<RetrievalState<InternalTrainingVM[]>>(initialState, builder => {
  builder.addCase(adminRetrieveInternalTrainings.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(adminRetrieveInternalTrainings.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(adminRetrieveInternalTrainings.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
  builder.addCase(resetAdminRetrieveInternalTrainings, () => {
    return initialState;
  });
});
